module.exports = __webpack_public_path__ + "img/top-4-4.ffc13884.jpg";